export default "__VITE_PUBLIC_ASSET__d4e738db__"